export const bejWorks = {
  play: [
    {
      id: 1,
      title: '인천 연수 능허대 문화축제 전통의상 갈라쇼',
      year: '2024'
    }
  ],
  show: [
    {
      id: 1,
      title: '[KBS Drama] 중매술사2',
      year: '2025'
    }
  ],
  commercial: [
    {
      id: 1,
      title: '한복상점 패션쇼 오퍼레이터',
      year: '2024', 
    },
    {
      id: 2,
      title: '그리니치 요가 모델',
      year: '2023', 
    },
    {
      id: 3,
      title: '아시아모델 페스티벌',
      year: '2023', 
    },
    {
      id: 4,
      title: '인사동 K-Beauty 홍보대사',
      year: '2023', 
    },
    {
      id: 5,
      title: '농협 하나로마트 광고',
      year: '2023', 
    },
    {
      id: 6,
      title: '샐리브라이드 웨딩 모델',
      year: '2022', 
    },
    {
      id: 7,
      title: 'DDP 내나라여행박람회 한복패션쇼 모델',
      year: '2022', 
    },
    {
      id: 8,
      title: '바이온 홈쇼핑 모델',
      year: '2022', 
    },
    {
      id: 9,
      title: '필리핀 관광청 한국 홍보대사',
      year: '2024', 
    },
    {
      id: 10,
      title: '아시아모델페스티벌 패션쇼 모델',
      year: '2022', 
    },
    {
      id: 11,
      title: '골프 바이온 전속모델',
      year: '2022', 
    },
  ]
}; 